module.exports = __webpack_public_path__ + "img/barcode.ce27fdfc.svg";